var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFeature6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.363 5.25a6.08 6.08 0 00-4.34 1.82l-.894.913-.903-.915a6.09 6.09 0 00-8.68 0 6.283 6.283 0 000 8.794l9.583 9.7 9.576-9.7a6.282 6.282 0 000-8.794 6.08 6.08 0 00-4.342-1.818zM28 52.5h-3.5v-8.75a5.256 5.256 0 00-5.25-5.25h-7A5.255 5.255 0 007 43.75v8.75H3.5v-8.75A8.76 8.76 0 0112.25 35h7A8.76 8.76 0 0128 43.75v8.75zM15.75 17.5a5.25 5.25 0 110 10.499 5.25 5.25 0 010-10.499zm0-3.5a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5z",
    fill: "#fff"
  })));
}
export default SvgHomeFeature6;